import { BarcodeFormat } from "@zxing/library";
import { CameraScanner } from "../shared/CameraScanner";

export function BarcodeScanner({ onDetected }) {
    return (
        <CameraScanner
            onDetected={onDetected}
            formats={[BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.UPC_A, BarcodeFormat.UPC_E]}
            label="Ler Código de Barras"
            scanningHint="Aponte a câmera para o código de barras."
            closeAriaLabel="Fechar leitor de código de barras"
            viewfinderStyle={{ width: "82vw", height: "26vh" }}
        />
    );
}
